import type { ReactNode } from 'react'
import { Link, Navigate, Outlet, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@claritio/frontend/lib/auth'
import { Button } from '@claritio/frontend/components/ui/button'
import Logo from '@claritio/frontend/components/Logo'

// Route guard: keeps the pages from firing requests the server would refuse.
export function RequireSponsorProcesses() {
  const { me } = useAuth()
  return me?.user?.process_intelligence_access ? <Outlet /> : <Navigate to="/employee/dashboard" replace />
}

export default function SponsorPage({ title, back, children }: { title: string; back?: { to: string; label: string }; children: ReactNode }) {
  const { t } = useTranslation('admin')
  const { me, logout } = useAuth()
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-20 border-b bg-background/80 backdrop-blur-sm">
        <div className="mx-auto flex h-14 max-w-6xl items-center gap-6 px-6">
          <Link to="/employee/dashboard"><Logo size="sm" /></Link>
          <div className="ml-auto flex items-center gap-3">
            {me?.user?.name && <span className="text-sm text-muted-foreground">{me.user.name}</span>}
            <Button variant="ghost" size="sm" onClick={async () => { if (await logout()) navigate('/employee/login') }}>{t('interview:dashboard.signOut')}</Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl space-y-6 px-6 py-8">
        {back && <Link to={back.to} className="text-sm text-muted-foreground hover:text-foreground">{back.label}</Link>}
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {children}
      </main>
    </div>
  )
}
